module.exports = __webpack_public_path__ + "img/xpu-ha-resort-2.4e5cd4fd.jpg";